// How often a BLE session repaints its headline numbers in React (#189).
//
// Every repaint re-renders everything that reads ConnectedEquipmentContext.
// During a workout the numbers need to move smoothly; outside one, once a
// second is plenty; with the app out of view nobody is looking, so skip it.
// Subscribers (charts, telemetry, the timer relay) still get every packet.

export const WORKOUT_HEADLINE_MS = 250;
export const IDLE_HEADLINE_MS = 1000;

export const pageHidden = () =>
  typeof document !== "undefined" && document.visibilityState === "hidden";

/** Milliseconds between repaints, or null for none. */
export const headlineInterval = ({ workoutActive, hidden }) => {
  if (hidden) return null;
  return workoutActive ? WORKOUT_HEADLINE_MS : IDLE_HEADLINE_MS;
};

/** Whether a packet at `now` should repaint, given the last repaint time. */
export const headlineDue = (lastAt, now, opts) => {
  const ms = headlineInterval(opts);
  return ms !== null && now - lastAt >= ms;
};
